/**
 * Moudule dependencies.
 */

import { colors } from './colors';
import { createTheme } from '@mui/material/styles';

/**
 * Export `theme`.
 */

export const theme = createTheme({
  cssVariables: true,
  custom: {
    colors,
  },
  typography: {
    fontFamily: 'var(--font-roboto)',
  },
} as any);
